import React, {useState} from "react";
import {Button, FormControl, InputLabel} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Grid from "@material-ui/core/Grid";
import {getTotalHowManyFiltersApplied} from "../../../../../../shared/utils/utils";
import Typography from "@material-ui/core/Typography";
import DefaultSelect from "../../../../../ui/inputs/selects/default-select/DefaultSelect";
import {updateObject} from "../../../../../../shared/utils/updateObject";
import {useSelector} from "react-redux";
import Input from "@material-ui/core/Input/Input";
import DefaultDatePicker from "components/ui/inputs/default-date-picker/DefaultDatePicker";

const EsitoCambioFormatoDialog = (props) => {
    const [currentFilters, setCurrentFilters] = useState(props.filter)
    const filterOptions = useSelector(state => state.eSimReducer.esitoCambioFormatoFilterOptions.data);

    const handleApplyFilters = () => {
        props.handleFilterSearch(currentFilters)
        props.handleDialogClose()
    }

    const handleSelectChange = (e) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
            [e.target.name]: updateObject(prevCurrentFilter[e.target.name],
                {value: e.target.value, text: e.currentTarget.innerText})
        }))
    }

    const handleInputChange = (e) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
            [e.target.name]: updateObject(prevCurrentFilter[e.target.name],
                {value: e.target.value})
        }))
    }

    const handleDateChange = (name, value) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
            dataInvioRichiesta: updateObject(prevCurrentFilter.dataInvioRichiesta, {[name]: value})
        }))
    }

    const esitoCambioFormato = [
        {
            text: "Riuscito",
            value: "Riuscito"
        },
        {
            text: "Non Riuscito",
            value: "Non Riuscito"
        }
    ]

    const dialogContent = (
        <>
            <Typography variant="h5">
                Filtri
            </Typography>

            <Grid container item
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Esito cambio formato
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <DefaultSelect menuItems={esitoCambioFormato}
                                   value={currentFilters.esitoCambioFormato.value}
                                   handleOnChange={handleSelectChange}
                                   label="Seleziona"
                                   name="esitoCambioFormato"
                                   fullWidth
                                   hasEmptyItem/>
                </Grid>
                </Grid>

            <Grid container item
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Numero di Telefono
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <FormControl fullWidth>
                        <InputLabel>Seleziona numero di telefono</InputLabel>
                        <Input
                            labelid="filterSearchLabel"
                            type="search"
                            autoComplete="off"
                            name="numeroDiTelefono"
                            onChange={handleInputChange}
                            value={currentFilters.numeroDiTelefono.value}
                            fullWidth
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container item
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Numero Seriale
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <FormControl fullWidth>
                        <InputLabel>Seleziona numero seriale</InputLabel>
                        <Input
                            labelid="filterSearchLabel"
                            type="search"
                            autoComplete="off"
                            name="numeroSeriale"
                            onChange={handleInputChange}
                            value={currentFilters.numeroSeriale.value}
                            fullWidth
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container item
                      alignItems="flex-end"
                      spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Data invio richiesta
                    </Typography>
                </Grid>
                <Grid item
                      container
                      xs={12} sm={7} md={8}
                      spacing={1}>
                    <Grid item>
                        <DefaultDatePicker
                            label="Da"
                            minValue={undefined}
                            date={currentFilters.dataInvioRichiesta.from}
                            setDate={(val) => handleDateChange('from', val)}/>
                    </Grid>
                    <Grid item>
                        <DefaultDatePicker
                            label="A"
                            minValue={currentFilters.dataInvioRichiesta.from ?? undefined}
                            date={currentFilters.dataInvioRichiesta.to}
                            setDate={(val) => handleDateChange('to', val)}/>
                    </Grid>
                </Grid>
                </Grid>

            <Grid container item
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        ID lotto
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <FormControl fullWidth>
                        <InputLabel>Cerca ID</InputLabel>
                        <Input
                            labelid="filterSearchLabel"
                            type="search"
                            autoComplete="off"
                            name="idLotto"
                            onChange={handleInputChange}
                            value={currentFilters.idLotto.value}
                            fullWidth
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )

    const dialogActions = (
        <>
            <Grid container
                  justifyContent="space-between">
                <Button variant="outlined"
                        color="primary"
                        onClick={props.handleDialogClose}>
                    Annulla
                </Button>

                <Button variant="contained"
                        disabled={!getTotalHowManyFiltersApplied(currentFilters)}
                        onClick={handleApplyFilters}
                        color="primary">
                    Applica {getTotalHowManyFiltersApplied(currentFilters) !== 0 ?
                    ` (${getTotalHowManyFiltersApplied(currentFilters)})` : ""}
                </Button>
            </Grid>
        </>
    )
    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogClose}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
            loading={false}>

            <Button variant="text"
                    color="primary"
                    onClick={props.handleDialogClose}
                    startIcon={<ArrowBackIosIcon fontSize="small"/>}>
                Indietro
            </Button>

        </GenericDialog>
    )
};

export default EsitoCambioFormatoDialog;